import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { NotificationCenterService } from '@clavisco/notification-center';
import { AlertsService, CLToastType } from '@clavisco/alerts';

/**
 * <summary>
 * Guard that checks if the user is authenticated before allowing access to a route.
 * If the user is not authenticated, they are redirected to the login page.
 * </summary>
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private alertService: AlertsService,
  ) {
  }

  /**
  * <summary>
  * Determines if the route can be activated by checking if the user is authenticated.
  * If not authenticated, the user will be redirected to the login page and shown an error toast message.
  * </summary>
  * @param route The route that is being navigated to.
  * @param state The state of the router at the time of navigation.
  * @returns A boolean, observable, or UrlTree indicating whether the route can be activated.
  */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.IsAuthenticated()) {
      return true;
    } else {
      this.alertService.Toast({
        message: 'No tienes acceso a esta sección, para continuar por favor inicia sesión.',
        type: CLToastType.ERROR,
      });
      this.authService.Logout();
      const urlTree: UrlTree = this.router.createUrlTree(['/login'], {});
      this.router.navigateByUrl(urlTree);
      return false;
    }
  }


}
